import masksHero from '@/assets/products/masks-hero.png';
import masksTexture from '@/assets/products/masks-texture.png';
import serumHero from '@/assets/products/serum-hero.png';
import serumTexture from '@/assets/products/serum-texture.png';
import creamHero from '@/assets/products/cream-hero.png';
import creamTexture from '@/assets/products/cream-texture.jpeg';
import bundleHero from '@/assets/products/bundle-hero.png';
import bundleLifestyle from '@/assets/products/bundle-lifestyle.png';

export interface ProductImage {
  src: string;
  altKey: string;
}

const productImageMap: Record<string, ProductImage[]> = {
  'pdrn-pink-sheet-masks-10-pack': [
    { src: masksHero, altKey: 'productImages.masks.hero.alt' },
    { src: masksTexture, altKey: 'productImages.masks.texture.alt' },
  ],
  'pink-glow-serum-with-pdrn-peptides': [
    { src: serumHero, altKey: 'productImages.serum.hero.alt' },
    { src: serumTexture, altKey: 'productImages.serum.texture.alt' },
  ],
  'smart-capsule-cream-with-collagen': [
    { src: creamHero, altKey: 'productImages.cream.hero.alt' },
    { src: creamTexture, altKey: 'productImages.cream.texture.alt' },
  ],
  'complete-pdrn-trio-bundle': [
    { src: bundleHero, altKey: 'productImages.bundle.hero.alt' },
    { src: bundleLifestyle, altKey: 'productImages.bundle.lifestyle.alt' },
  ],
};

// Fuzzy keyword map for partial handle matching
const keywordMap: Record<string, string> = {
  mask: 'pdrn-pink-sheet-masks-10-pack',
  serum: 'pink-glow-serum-with-pdrn-peptides',
  glow: 'pink-glow-serum-with-pdrn-peptides',
  cream: 'smart-capsule-cream-with-collagen',
  capsule: 'smart-capsule-cream-with-collagen',
  trio: 'complete-pdrn-trio-bundle',
  bundle: 'complete-pdrn-trio-bundle',
  set: 'complete-pdrn-trio-bundle',
};

export function getProductImages(handle: string): ProductImage[] {
  // Exact match first
  if (productImageMap[handle]) {
    return productImageMap[handle];
  }

  // Fuzzy match by keyword
  for (const [keyword, mappedHandle] of Object.entries(keywordMap)) {
    if (handle.includes(keyword)) {
      return productImageMap[mappedHandle] || [];
    }
  }

  return [];
}
